package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

/** A visitor's request to join while the service is invite-only. */
@Serializable
data class AccessRequestDto(
    val email: String,
    val name: String = "",
    val message: String = "",
    val locale: String? = null,
    val ageConfirmed: Boolean = false,
    val privacyAccepted: Boolean = false
)

@Serializable
data class AccessRequestAdminDto(
    val id: Long,
    val email: String,
    val name: String,
    val message: String?,
    val status: String,
    val createdAtMs: Long,
    val decidedAtMs: Long? = null,
    val decidedBy: String? = null
)
